import { Component, ViewChild } from '@angular/core';
import { Device } from './models';
import { WindowRefService } from '@services/window.service';
import { HttpClient } from '@angular/common/http';
import { Observable, timer, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DeviceService } from '../../services/device.service';
import { AppComponent } from '../../app.component';
import { trigger, state, style, animate, transition, } from '@angular/animations';
import { SignalRService } from '../../services/signalr.service';
import { SearchMenuComponent } from './search-menu/search-menu.component';
import { GoogleDeviceMapComponent } from './google-map/google-device-map.component';

@Component({
  selector: 'app-camera-realtime-map',
  templateUrl: './camera-realtime-map.component.html',
  styleUrls: ['./camera-realtime-map.component.scss'],
  providers: [WindowRefService, SignalRService, DeviceService],
  animations: [
    trigger('mapAnimate', [
      state('menuOpen', style({
        width: 'calc(100% - 310px)',
        'min-width': 'calc(1048px - 310px)',
        'margin-left': '300px',
      })),
      state('menuClosed', style({
        width: 'calc(100% - 20px)',
        'min-width': '1048px',
        'margin-left': '10px',
      })),
      transition('menuOpen => menuClosed', [
        animate('0.2s ease-in-out')
      ]),
      transition('menuClosed => menuOpen', [
        animate('0.2s ease-in-out')
      ]),
    ]),
    trigger('menuAnimate', [
      state('menuOpen', style({
        opacity: '1',
      })),
      state('menuClosed', style({
        opacity: '0',
      })),
      transition('menuOpen => menuClosed', [
        animate('0.2s ease-in-out')
      ]),
      transition('menuClosed => menuOpen', [
        animate('0.2s ease-in-out')
      ]),
    ]), ,
    trigger('streamAnimate', [
      state('menuOpen', style({
        'margin-left': '0px',
      })),
      state('menuClosed', style({
        'margin-left': '-290px',
      })),
      transition('menuOpen => menuClosed', [
        animate('0.2s ease-in-out')
      ]),
      transition('menuClosed => menuOpen', [
        animate('0.2s ease-in-out')
      ]),
    ]),
  ]
})
export class CameraRealtimeMapComponent {

  apiLoaded: Observable<boolean>;
  searchMenuOpen: boolean = false;
  devices: Device[] = [];
  searchText: string;
  streamEnabled: boolean = false;
  cameraOfflineTimeout: number = 60;
  selectedDevice: Device;

  @ViewChild(SearchMenuComponent) searchMenu: SearchMenuComponent;
  
  constructor(
    httpClient: HttpClient,
    private deviceService: DeviceService,
    app: AppComponent
  ) {

    this.streamEnabled = !!app.getAttribute("hlsEnabled");
    this.cameraOfflineTimeout = app.getAttribute("cameraOfflineTimeout");
    
    this.deviceService.devicesUpdated.subscribe((devices: Device[]) => {
      this.devices = devices;
    });

    timer(0, 10000).subscribe(n => {
      this.deviceService.getFilteredDevices()
        .then(devices => this.devices = devices);
    });

    // Load google maps. In future other maps may need to be loaded here
    let googleApiKey: string = app.getAttribute("googleApiKey");
    this.apiLoaded = httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=' + googleApiKey, 'callback')
      .pipe(
        map(() => true),
        catchError((err: any) => {
          console.log(err);
          return of(false);
        }),
      );

  }

  public toggleSearchMenu(isOpen: boolean) {
    this.searchMenuOpen = isOpen;
    if (!isOpen) {
      this.searchMenu.clearSearch();
      this.deviceService.clearSearch();
    }

  }

  deselectDevice() {
    this.selectedDevice = null;
  }

  public loadStream(device: Device) {

    // Should only attempt to open a stream for a streaming ICV
    if (!device.isStreaming) {
      return;
    }

    this.deviceService.setDeviceSelected(device);
    this.selectedDevice = device;

  }
}
